var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.fullName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }